class EditableContent {
  constructor(wrapper) {
    this.wrapper = wrapper
      ? wrapper
      : document.querySelector(".editable-content");
    this.field =
      this.wrapper && this.wrapper.querySelector(".editable-content-field");
    this.trigger =
      this.wrapper && this.wrapper.querySelector(".editable-content-trigger");
  }

  validate() {
    if (!this.wrapper || !this.trigger || !this.field) {
      return false;
    } else {
      return true;
    }
  }

  hover(target, mouseenter) {
    let wrapper = target.closest(".editable-content");

    mouseenter
      ? wrapper.classList.add("editable-content-hover")
      : wrapper.classList.remove("editable-content-hover");
  }

  editModeOn(target) {
    let wrapper = target.closest(".editable-content"),
      field = wrapper.querySelector(".editable-content-field");

    let isSelectBar = field.classList.contains("form-select");
    let isDynamicSelectBar = field.classList.contains(
      "select2-hidden-accessible"
    );

    if (isSelectBar && isDynamicSelectBar) {
      field = wrapper.querySelector(".select2-selection");

      field.addEventListener("blur", ({ target }) => {
        setTimeout(() => {
          !document.activeElement.classList.contains("select2-search__field") &&
            this.editModeOff(target);
        }, 100);
      });
    }

    wrapper.classList.add("active");
    !isDynamicSelectBar && field.removeAttribute("readonly");
    field.focus();
  }

  editModeOff(target) {
    target.closest(".editable-content").classList.remove("active");
    target.setAttribute("readonly", "true");
  }

  attachEventListener() {
    this.trigger.addEventListener("mouseenter", ({ target }) => {
      this.hover(target, "mouseenter");
    });

    this.trigger.addEventListener("mouseleave", ({ target }) => {
      this.hover(target);
    });

    this.trigger.addEventListener("click", ({ target }) => {
      this.editModeOn(target);
    });

    this.field.addEventListener("blur", ({ target }) => {
      this.editModeOff(target);
    });
  }

  initNewEditable(item) {
    // Update variable
    this.wrapper = item;
    this.field = this.wrapper.querySelector(".editable-content-field");
    this.trigger = this.wrapper.querySelector(".editable-content-trigger");

    if (this.validate()) {
      this.attachEventListener();
    }
  }

  init() {
    document.querySelectorAll(".editable-content").forEach((item) => {
      this.initNewEditable(item);
    });
  }
}

const editableContent = new EditableContent();
editableContent.init();
